import React, { useEffect, useState } from 'react'
import BomTabsData from './BomTabsData/BomTabsData';
import Bom from "@system/config/bom";
import { useBOMStore } from "../../../hooks/bom";
import { isObject } from "underscore";
import { useCartStore } from 'src/hooks/cart';
import System from "../../../helper/system";
import useReduxState from "../../../hooks/useReduxState";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import produceClone from 'src/helper/produceClone';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import { __set, __remove } from 'src/store/axios_indicator';
import Constants from 'src/helper/Constants';
import liveAuth from 'src/helper/liveAuth';
import BomExactMatchTable from './BomTabsData/BomExactMatchTable';
import BomMultipleMatchTable from './BomTabsData/BomMultipleMatchTable';
import BomNoMatchTable from './BomTabsData/BomNoMatchTable';
import { useProductStore } from 'src/hooks/product';
import QuoteRepository from 'src/repository/QuoteRepository';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import BomNewarkList from './BomNewarkList';

const bom_id = System.getParams().bomId;
const param_key_BomTabList = '__c_BomTabList';

const BomTabs = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ bom_detail_by_bom_id_type, bom_detail_Exact_list, bom_detail_Multiple_list, bom_detail_NoMatch_list, bomMultipleMatchTrigger, selected_fields, bom_detail_by_bom_id }, { get_bom_detail_by_bom_id_with_type, get_bom_detail_count_by_bom_id, }, { set_bom_multi_match_trigger, USERS_WITH_ABANDONED_BOM_FOR_72_HOURS }] = useBOMStore();
    const [top, SetTop] = useReduxState({}, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT', true);
    const [{ }, { get_display_status_button, check_item_exists_in_cart }, { add_cart_in_Bulk }] = useCartStore();
    const [validCartCount, setValidCartCount] = useState(0)
    const [validQuoteCount, setValidQuoteCount] = useState(0)
    const [{ bomPricingList }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
    const [checkoutFarnellClick, setCheckoutFarnellClick] = useReduxState(false, 'setCheckoutFarnellClick')
    const [headerDistance, setHeaderDistance] = useState(0);
    const { bomDetailPageTabs, currencyType: { USD } } = Constants
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState({ monitorJs: false, frameworkReady: false });
    const [{ productList }, { get_end_customer_by_cpn }, { }] = useProductStore();
    const [newarkToggleButton, setNewarkToggleButton] = useReduxState(false, 'newarkToggleButton')

    let defaultTabList = {
        Exact: {
            name: bomDetailPageTabs.BomExactMatchTable.tabHeader,
            param_value: bomDetailPageTabs.BomExactMatchTable.content,
            count: 0,
            icon: <i className="fa fa-check-circle me-1 text-darkgreen font-16" />,
            api_fetch_type: bomDetailPageTabs.BomExactMatchTable.api_fetch_type,
        },
        Multiple: {
            name: bomDetailPageTabs.BomMultipleMatchTable.tabHeader,
            param_value: bomDetailPageTabs.BomMultipleMatchTable.content,
            count: 0,
            icon: <i className="fa fa-warning me-1 text-yellow font-16" />,
            api_fetch_type: bomDetailPageTabs.BomMultipleMatchTable.api_fetch_type,
        },

        NoMatch: {
            name: bomDetailPageTabs.BomNoMatchTable.tabHeader,
            param_value: bomDetailPageTabs.BomNoMatchTable.content,
            count: 0,
            icon: <i className="fa fa-warning me-1 text-red font-16" />,
            api_fetch_type: bomDetailPageTabs.BomNoMatchTable.api_fetch_type
        }
    };

    const [homeTabList, setHomeTabList] = useState(defaultTabList)
    const [selectedTab, setSelectedTab] = useReduxState("BomExactMatchTable", "searchParams");
    const bomTabType = System.getParams().__c_BomTabList;
    const pricing = bomPricingList;
    const orderBlock = System.avUserInfoData.orderBlock;
    const avUserInfo = liveAuth.getAvUserInfo()

    const updateTabCounts = (counts) => {
        setHomeTabList((prevList) => ({
            ...prevList,
            Exact: { ...prevList.Exact, count: counts.Exact || 0 },
            Multiple: { ...prevList.Multiple, count: counts.Multiple || 0 },
            NoMatch: { ...prevList.NoMatch, count: counts.NoMatch || 0 }
        }));
    };
    useEffect(() => {
        async function fetchHere() {
            setSelectedTab(bomTabType ? bomTabType : "BomExactMatchTable");
        }

        fetchHere();
    }, [bomTabType]);

    useEffect(() => {
        async function f() {
            if (Object.entries(selected_fields).length > 0) {
                let cartCount = 0
                let quoteCount = 0
                let cartFirstIn = false
                let quoteFirstIn = false

                Object.entries(selected_fields).map(async (v) => {
                    if (bom_detail_Exact_list?.records?.hasOwnProperty(v[1]?.bomDetailId)) {
                        let bomDetailData = bom_detail_Exact_list.records[v[1].bomDetailId]
                        const _inventory = get_inventory_by_id(bomDetailData.itemNumber)
                        const _price = get_pricing_by_id({ uniqueId: v[1]?.bomDetailId })
                        let displayCart = get_display_status_button(productList[bomDetailData.itemNumber], _price, _inventory, 'cart')
                        let displayQuote = get_display_status_button(productList[bomDetailData.itemNumber], _price, _inventory, 'quote')
                        let displayQuoteForLink = get_display_status_button(productList[bomDetailData.itemNumber], _price, _inventory, 'quoteLink')
                        // let checkMinMalt = CART_BEFORE_TO_SEND_SERVER[bomDetailData.itemNumber].invalid_quantity
                        const checkMinMalt = System.checkValidQuantity(productList[bomDetailData.itemNumber], _inventory, v[1]?.quantity)

                        if (bomDetailData?.isDeleted !== null && bomDetailData?.isDeleted === false) {
                            if (displayCart && !checkMinMalt) {
                                cartFirstIn = true
                                setValidCartCount(cartCount += 1)
                            }
                            if (displayQuote || displayQuoteForLink) {
                                quoteFirstIn = true
                                setValidQuoteCount(quoteCount += 1)
                            }
                        }

                        if (!cartFirstIn) {
                            setValidCartCount(0)
                        }

                        if (!quoteFirstIn) {
                            setValidQuoteCount(0)
                        }
                    }
                })
            } else {
                setValidCartCount(0)
                setValidQuoteCount(0)
            }
        }

        f()

    }, [selected_fields]);


    useEffect(() => {
        async function fetchHere() {
            if (bomMultipleMatchTrigger === 'BOM_EXACT_TRIGGER' &&
                ((bom_detail_Multiple_list?.matchType === bomDetailPageTabs?.BomMultipleMatchTable?.api_fetch_type) ||
                    bom_detail_NoMatch_list?.matchType === bomDetailPageTabs?.BomNoMatchTable?.api_fetch_type
                )) {
                await switchTab(getTabLink(homeTabList.Exact), homeTabList.Exact, true);
            }
            setFirstServerCall(false)
        }
        if (!monitorFunctionCall.monitorJs) {
            System.monitorJSDx()
            setMonitorFunctionCall({ ...monitorFunctionCall, monitorJs: true })
        }
        fetchHere()
        updateTabCounts({
            Exact: bom_detail_Exact_list?.count,
            Multiple: bom_detail_Multiple_list?.count,
            NoMatch: bom_detail_NoMatch_list?.count
        });

    }, [bom_detail_by_bom_id_type])


    useEffect(() => {
        async function f() {
            await autoBOMRedirection(bom_id);
        }
        f()
    }, []);

    async function autoBOMRedirection(bom_id) {
        let resp = await get_bom_detail_count_by_bom_id({ bomId: bom_id });
        updateTabCounts({
            Exact: resp?.payload?.Exact?.count,
            Multiple: resp?.payload?.Multiple?.count,
            NoMatch: resp?.payload?.NoMatch?.count
        });
        if (!monitorFunctionCall.frameworkReady) {
            System.monitorFrameWorkReady()
            setMonitorFunctionCall({ ...monitorFunctionCall, frameworkReady: true })
        }
        if (resp?.payload) {
            if (resp.payload.Exact && resp.payload.Exact.count > 0) {
                return switchTab(getTabLink(homeTabList.Exact), homeTabList.Exact);
            } else if (resp.payload.Multiple && resp.payload.Multiple.count > 0) {
                return switchTab(getTabLink(homeTabList.Multiple), homeTabList.Multiple);
            } else if (resp.payload.NoMatch && resp.payload.NoMatch.count > 0) {
                return switchTab(getTabLink(homeTabList.NoMatch), homeTabList.NoMatch);
            } else if (resp.payload.Exact && resp.payload.Exact.deleted > 0) {
                return switchTab(getTabLink(homeTabList.Exact), homeTabList.Exact);
            } else if (resp.payload.Multiple && resp.payload.Multiple.deleted > 0) {
                return switchTab(getTabLink(homeTabList.Multiple), homeTabList.Multiple);
            } else if (resp.payload.NoMatch && resp.payload.NoMatch.deleted > 0) {
                return switchTab(getTabLink(homeTabList.NoMatch), homeTabList.NoMatch);
            }
        }
    }

    const getActiveClass = (singleElement) => {
        if (selectedTab === singleElement.param_value) {
            return 'active'
        }
        return ''
    };
    const getTabLink = (singleElement) => {
        return Bom.getBomTabsListRouteURL({
            [param_key_BomTabList]: singleElement.param_value
        });
    };
    const switchTab = async (url, chain_single, isBOMExactRedirect = false) => {
        SetTop({
            NoMatch: { top: 20 },
            Multiple: { top: 20 },
            Exact: { top: 20 }
        })
        if (isBOMExactRedirect && bomMultipleMatchTrigger !== '') {
            set_bom_multi_match_trigger({
                BOMTriggerVal: '' // reset value 
            })
        }

        let top_here = 10;
        if (top[chain_single.api_fetch_type] && top[chain_single.api_fetch_type].top) {
            top_here = top[chain_single.api_fetch_type].top;
        }
        top_here = top_here === 10 ? 20 : top_here;
        await get_bom_detail_by_bom_id_with_type({
            bomId: bom_id,
            matchType: chain_single.api_fetch_type,
            isReRunPartMatch: false,
            top: top_here,
            sortOrder: isBOMExactRedirect ? 'desc' : 'asc',
            sortColumn: isBOMExactRedirect ? 'updated_date' : null
        });


        history.pushState('', '', url);
    };

    const AddBulkQuote = async () => {
        let QuoteItems = [];
        let bomProduct = [];
        if (Object.entries(selected_fields).length > 0) {
            await Promise.all(Object.entries(selected_fields).map(async (v) => {
                if (bom_detail_Exact_list?.records.hasOwnProperty(v[1].bomDetailId)) {
                    const product = productList[v[1].ERPPartNumber];
                    bomProduct.push(productList[v[1].ERPPartNumber]);
                    const _inventory = get_inventory_by_id(product.ItemNumber);
                    const _price = get_pricing_by_id({ uniqueId: v[1].bomDetailId });

                    let displayQuote = get_display_status_button(product, _price, _inventory, 'quote')
                    let displayQuoteForLink = get_display_status_button(product, _price, _inventory, 'quoteLink')

                    if ((displayQuote || displayQuoteForLink) && v[1].isDeleted === false) {

                        let _quote = {
                            partNumber: product?.ERPPartNumber,
                            manufacturerPartNumber: product.ManufacturerPartNumber,
                            manufacturerCode: product.ManufacturerCode,
                            manufacturerName: product.ManufacturerName,
                            customerPartNumber: v[1]?.customerPartNumber || '',
                            itemNumber: product?.ItemNumber,
                            quantity1: new QuoteRepository().getRFQMinQty(product, _price),
                            targetCurrency: USD,
                            targetUnitPrice: null,
                            endCustomer: "",
                            competition: "",
                            comments: "",
                            ERPMFRPartNumber: product?.ERPMFRPartNumber,
                            erpManufacturerPartNumber: product?.ERPMFRPartNumber,
                            min: product?.QtyMin,
                            mult: product?.QtyMult,
                            erpManufacturerName: product?.ERPManufacturerName,
                            erpManufacturerCode: product?.ERPManufacturerCode,
                        };

                        const cloneObj = produceClone(_quote);
                        QuoteItems.push(cloneObj);
                    }
                }
            }));
        }
        System.popup('ValidateRFQQuoteRequest', { quoteFrom: 'BOMQuote', quoteList: QuoteItems, addQuote: bomProduct })

        let erpMFRList = Object.entries(QuoteItems).map((data) => {
            return data[1]?.product?.ERPMFRPartNumber
        }).join(", ")

        System.setEvars(erpMFRList, 'Add to Quote clicked from BOM', 'BOM')

    }

    const onFarnellCheckout = () => {
        if (window?.digitalData) {
            window.digitalData.event.eventinfo.events = "Farnell Checkout clicked";
        }
        //code added by Ramya
        let linkDetails = {
            linkName: "Click here to checkout",
            linkUrl: window.location.href,
            linkLocation: window.document.title,
            linkType: "Button",
            linkComponent: "BOM Page",
        }
        localStorage.setItem("adobeEventType", "CTAClickEvent");
        HelperAdobeEvent.trackingAdobeEvent({
            linkDetails
        })
    }

    const AddToCart = async () => {
        let cartItems = [];
        let checkItemParam = []
        let validBomDetailId = []
        let checkExistingItemResponse = false
        if (Object.entries(selected_fields).length > 0) {
            Object.entries(selected_fields).filter(obj => {
                let items = {}
                if (obj[1]?.customerPartNumber !== null) {
                    items = { itemNumber: productList[obj[1].ERPPartNumber]?.ItemNumber, cpn: obj[1]?.customerPartNumber }
                    checkItemParam.push(items)
                }
            })

            if (checkItemParam?.length > 0 && (System.avUserInfoData.currentUser === Constants.siteUser.CORE)) {
                checkExistingItemResponse = await check_item_exists_in_cart({ items: checkItemParam })
            }

            if (checkExistingItemResponse === true) {
                let productParam = []
                Object.entries(selected_fields).map(async (v) => {
                    const product = productList[v[1].ERPPartNumber];
                    productParam.push({
                        "quantity": v[1].quantity ? v[1].quantity : 1,
                        "currency": USD,
                        "backOrderedQuantity": 0,
                        "cpn": v[1].customerPartNumber,
                        "VendorCode": product.VendorCode,
                        "SAPMatGroup": product.SAPMatgroup,
                        "partNumber": product.ERPPartNumber,
                        "ItemNumber": product.ItemNumber,
                        "ManufacturerPartNumber": product.ManufacturerPartNumber,
                        "ManufacturerCode": product.ManufacturerCode,
                        "ManufacturerName": product.ManufacturerName,
                        "AssetURL": product.AssetURL,
                        "type": "Shopping",
                        "ERPMFRPartNumber": product.ERPMFRPartNumber,
                        "ERPManufacturerName": product.ERPManufacturerName,
                        "ERPManufacturerCode": product.ERPManufacturerCode,
                        'isSoftwareDownloadable': product?.SoftwareDownloadFlag,
                        'mdmMaterialId': product?.MDMMaterialID,
                    })
                    validBomDetailId.push({ bomDetailsId: v[1].bomDetailId });
                })

                System.popup('BomToCartItemReplacePopup', {
                    cartReplaceItem: { "cartItems": productParam }, validBomDetailId
                })
            } else {
                await Promise.all(Object.entries(selected_fields).map(async (v) => {
                    if (bom_detail_Exact_list?.records.hasOwnProperty(v[1].bomDetailId)) {
                        const product = productList[v[1].ERPPartNumber];
                        const _inventory = get_inventory_by_id(product.ItemNumber);
                        const _price = get_pricing_by_id({ uniqueId: v[1].bomDetailId });

                        let displayCart = get_display_status_button(product, _price, _inventory, 'cart');
                        const checkMinMalt = System.checkValidQuantity(product, _inventory, v[1]?.quantity)
                        // let checkMinMalt = CART_BEFORE_TO_SEND_SERVER[product?.ItemNumber]?.invalid_quantity

                        if (displayCart && v[1].isDeleted === false && !checkMinMalt) {

                            let cartItemParams = {
                                partNumber: product.ERPPartNumber,
                                ItemNumber: product.ItemNumber,
                                ManufacturerPartNumber: product.ManufacturerPartNumber,
                                ERPMFRPartNumber: product.ERPMFRPartNumber,
                                manufacturerCode: product.ManufacturerCode,
                                quantity: v[1].quantity ? v[1].quantity : 1,
                                // backOrderedQuantity: 0,
                                manufacturerName: product.ManufacturerName,
                                cpn: v[1].customerPartNumber ? v[1].customerPartNumber : '',
                                currency: USD,
                                ShortDescription: product.ShortDescription,
                                AssetURL: product.AssetURL,
                                erpManufacturerName: product.ERPManufacturerName,
                                erpManufacturerCode: product.ERPManufacturerCode,
                                type: "Shopping",
                                "default_plant": product.default_plant,
                                "mdmMaterialId": product?.MDMMaterialID,
                                endCustAccNum: get_end_customer_by_cpn(product.CustomerPartNumbers, v[1].customerPartNumber),
                                'isSoftwareDownloadable': product?.SoftwareDownloadFlag,
                            };
                            validBomDetailId.push({ bomDetailsId: v[1].bomDetailId });
                            const cloneObj = produceClone(cartItemParams);
                            cartItems.push(cloneObj);
                        }
                    }
                }));


                let params = {
                    currency: USD,
                    cartItems: cartItems
                };

                let selectedProductData = await add_cart_in_Bulk(params);
                USERS_WITH_ABANDONED_BOM_FOR_72_HOURS(validBomDetailId)

                System.popup('AddedToCartBomPopup', { cartData: selectedProductData, isCartBOM: true });
                let erpMFRList = selectedProductData.map((data) => data.erpMfrPartNumber).join(", ");
                System.setEvars(erpMFRList, 'ATC clicked from BOM', "BOM");
            }

        };
    }

    const openContactUsPopup = () => {
        System.popup('ContactUsPopup', { restrict: true, order_block: orderBlock })
    };


    const getContactUsButton = () => {
        return (
            <button onClick={() => { openContactUsPopup() }}
                className='bs5 btn btn-primary click-to-quote-btn'>
                Contact Us
            </button>
        )
    };

    useEffect(() => {
        const handleScroll = () => {
            let tableHeader = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight - 1 : 65 + 1
            if (tableHeader) {
                const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;
                if (adminToolBarHeight > 0) {
                    tableHeader = tableHeader + adminToolBarHeight;
                }

                setHeaderDistance(tableHeader);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // const OnfarnellChackout = () => {
    //     const div = document.getElementById('BOMStickyHeader')
    //     div.style.zIndex = 99

    //     System.popup('RegisterDesignPopup', {})
    // }


    return (
        <>

            <div className="container">
                {!newarkToggleButton &&
                    <div className='primary-bg-color order-prototype' id="BOMStickyHeader" style={{ position: 'sticky', top: headerDistance, zIndex: '999' }}>
                        <div className="mb-3 mb-md-0 ps-4 order-prototype-container text-center position-relative">
                            <div className='d-block d-lg-flex justify-content-md-start order-prototype-content'>
                                <div className='d-flex'>
                                    <span className='order-prototype-icon me-2' style={{ marginTop: '6px' }}></span>
                                    Need Smaller Quantities? Order Prototype Quantities For Below Parts at Newark -
                                </div>
                                 {/* <a href='https://www.newark.com/' className="bs5 ms-1 text-decoration-underline" target={"_blank"}>www.newark.com </a> */}
                                <a href={void (0)} onClick={() => { setCheckoutFarnellClick(true); onFarnellCheckout() }} className="bs5 btn btn-primary-outline ms-3"> Click here to checkout </a>
                            </div>
                            <span className='newark-logo'></span>
                        </div>
                    </div>
                }
                <BomTabsData />
                {newarkToggleButton ? <BomNewarkList bomDetail={bom_detail_by_bom_id_type} bomInfo={bom_detail_by_bom_id} /> :
                    <div className="mb-5">
                        <div className='d-flex justify-content-between align-items-end bb1'>
                            <div className="mobile-tab bom-tab">
                                <ul className="bs5 nav nav-tabs border-bottom-0">

                                    {Object.entries(homeTabList).map((v) => (
                                        <React.Fragment key={v[1].name}>
                                            {<li key={v[1].name} className="maxw-auto">
                                                <a className={'w-auto text-uppercase font-bold ' + getActiveClass(v[1])}
                                                    href={void (0)}
                                                    onClick={async () => {
                                                        await switchTab(getTabLink(v[1]), v[1])
                                                    }}
                                                >{v[1].icon}
                                                    <span>
                                                        {v[1].name}
                                                        {__check(['BOM_TAB_API_CALL', 'BOM_API_CALL', 'CART_API_CALL']).status === false &&
                                                            <>
                                                                <span>  </span> {v[1].count}/{bom_detail_by_bom_id_type.totalMatches || 0}
                                                            </>
                                                        }
                                                    </span>
                                                </a>
                                            </li>
                                            }
                                        </React.Fragment>
                                    ))
                                    }
                                </ul>
                            </div>

                            {/* {(System.validateDomain(avUserInfo?.email) && bom_detail_by_bom_id_type?.isExternalBom) && (
                            <div className="tabs-text-top align-self-center  d-block drms-registration">
                                <span> DRMS Registration</span>
                                <button className="bs5 btn btn-primary minw-auto" onClick={() => OnfarnellChackout()}>Register Now</button>
                            </div>
                        )} */}
                            {isObject(selected_fields) &&
                                <div className="tabs-text-top align-self-center d-none d-lg-block">
                                    <>{liveAuth.check() &&
                                        <button
                                            className={(validQuoteCount < 1) ? 'bs5 btn btn-secondary me-3 w200 mb-3 mb-md-0 disabled' : 'bs5 btn btn-secondary me-3 w200 mb-3 mb-md-0'}
                                            disabled={validQuoteCount < 1}
                                            onClick={() => AddBulkQuote()}>add ({validQuoteCount}) Item(s) to quote
                                        </button>
                                    }
                                        {orderBlock ? getContactUsButton() :
                                            <>
                                                <button className="bs5 btn btn-primary w170 mb-3 mb-md-0"
                                                    onClick={(e) => {
                                                        __check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status ? e.preventDefault() : AddToCart()
                                                    }} disabled={validCartCount < 1}
                                                >
                                                    {__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status &&
                                                        <>
                                                            add ({validCartCount}) Item(s) to <i className="fa fa-spinner fa-spin" />
                                                        </>
                                                    }
                                                    {!__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status &&
                                                        <>
                                                            add ({validCartCount}) Item(s) to
                                                            <i className="fa fa-cart-plus ms-1" />
                                                        </>
                                                    }
                                                </button>
                                            </>
                                        }
                                    </>
                                </div>
                            }
                        </div>
                        <div
                            id={selectedTab}
                            className="tab-pane active table-container">
                            {selectedTab === defaultTabList.Exact.param_value && <BomExactMatchTable current_chain={homeTabList.Exact} />}
                            {selectedTab === defaultTabList.Multiple.param_value && <BomMultipleMatchTable current_chain={homeTabList.Multiple} />}
                            {selectedTab === defaultTabList.NoMatch.param_value && <BomNoMatchTable current_chain={homeTabList.NoMatch} />}
                        </div>
                    </div>
                }
            </div>

        </>
    );
}

export default BomTabs;